import React, { useState, memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX } = FiIcons;

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navigationLinks = [
    { path: '/', label: 'Home' },
    { path: '/healing-scriptures', label: 'Healing' },
    { path: '/bible-verses-about-strength', label: 'Strength' },
    { path: '/encouraging-verses', label: 'Encouraging' },
    { path: '/bible-verses-about-hope', label: 'Hope' },
    { path: '/christian-gifts', label: 'Gifts' }
  ];

  return (
    <nav className="bg-white/90 backdrop-blur-md border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-3 group">
            <img 
              src="https://cdn1.sharemyimage.com/smi/2026/01/24/Encouraging-Bible-Verses-Logo-Clear.png" 
              alt="Encouraging Bible Verses" 
              className="h-10 w-auto transform transition-transform group-hover:scale-105"
              loading="eager"
              width="40"
              height="40"
            />
            <span className="text-xl font-bold text-gray-900 hidden sm:block">Encouraging Bible Verses</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            {navigationLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-semibold transition-colors hover:text-indigo-600 px-1 py-2 ${
                  location.pathname === link.path 
                    ? 'text-indigo-600 border-b-2 border-indigo-600' 
                    : 'text-gray-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-md text-gray-700 hover:text-indigo-600 focus:outline-none"
            aria-label="Toggle menu"
          >
            <SafeIcon icon={isOpen ? FiX : FiMenu} className="h-6 w-6" />
          </button>
        </div>

        {/* Mobile Navigation */}
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="md:hidden border-t border-gray-100 overflow-hidden"
            >
              <div className="py-3 space-y-1">
                {navigationLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    onClick={() => setIsOpen(false)}
                    className={`block px-3 py-2.5 text-base font-medium transition-colors hover:bg-indigo-50 hover:text-indigo-600 ${
                      location.pathname === link.path ? 'text-indigo-600 bg-indigo-50/50' : 'text-gray-700'
                    }`}
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </nav>
  );
};

export default memo(Navigation);